/**
 * Info bubble for ops m³ vs billable m³ — MUI (quote preparation UI).
 */

import React from "react";
import { Box, IconButton, Stack, Tooltip, Typography } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { getVolumeMetricHelp } from "../utils/volumeMetricHelp.js";

/**
 * @param {object} props
 * @param {"ops"|"billable"|"inventorySection"} props.metric
 * @param {"small"|"medium"} [props.iconSize]
 * @param {boolean} [props.inline] — show label + icon (for section headings)
 */
const VolumeMetricHelpBubble = ({
  metric,
  iconSize = "small",
  inline = false,
}) => {
  const help = getVolumeMetricHelp(metric);
  const fontSize = iconSize === "medium" ? 18 : 15;

  const content = (
    <Box sx={{ maxWidth: 340, py: 0.25 }}>
      <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 0.75 }}>
        {help.title}
      </Typography>
      <Typography variant="body2" sx={{ mb: 1, lineHeight: 1.45 }}>
        {help.summary}
      </Typography>
      <Typography variant="caption" color="inherit" sx={{ opacity: 0.92, display: "block" }}>
        Example: {help.example}
      </Typography>
      {help.usedFor ? (
        <Typography
          variant="caption"
          color="inherit"
          sx={{ opacity: 0.85, display: "block", mt: 0.75 }}
        >
          Used for: {help.usedFor}
        </Typography>
      ) : null}
    </Box>
  );

  const trigger = inline ? (
    <Stack
      direction="row"
      alignItems="center"
      spacing={0.25}
      component="span"
      sx={{ cursor: "help", display: "inline-flex" }}
    >
      <Typography variant="inherit" component="span">
        {help.title.split(" (")[0]}
      </Typography>
      <InfoOutlinedIcon sx={{ fontSize, opacity: 0.65 }} />
    </Stack>
  ) : (
    <IconButton
      size="small"
      aria-label={`About ${help.title}`}
      sx={{ p: 0.2, ml: 0.25, verticalAlign: "middle" }}
      tabIndex={0}
    >
      <InfoOutlinedIcon sx={{ fontSize }} />
    </IconButton>
  );

  return (
    <Tooltip title={content} arrow placement="top" enterTouchDelay={0}>
      {trigger}
    </Tooltip>
  );
};

export default VolumeMetricHelpBubble;
